/** Unified asset-owner Apple login paths (role 4). Legacy routes kept as fallbacks. */
export const ASSET_OWNER_APPLE_LOGIN_PATHS = [
  'login/AssetOwner/apple',
  'login/BusinessAssetOwner/apple',
  'login/PrivateAssetOwner/apple',
  'login/assetsowners/apple',
  'login/apple',
] as const;

export const ASSET_OWNER_APPLE_REGISTER_PATHS = [
  'register/AssetOwner/apple',
  'register/AssetOwner',
  'register/BusinessAssetOwner/apple',
  'register/BusinessAssetOwner',
  'register/PrivateAssetOwner/apple',
  'register/PrivateAssetOwner',
] as const;
